import {Component,OnInit,Input, Output, EventEmitter, NgModule} from '@angular/core';
import {TreeNode,TreeModule,ContextMenuModule} from 'primeng/primeng';

import {UserGroup} from '../model/usergroup';
import {GuideService} from "../service/guide_service.component"
import {Logger, Options, Level } from "angular2-logger/core"; // ADD THIS

@Component({
    selector:'ex-usertree',
    templateUrl:'./user_tree.component.html'
})
export class UserGroupTreeComponent implements OnInit{
    private user_group:TreeNode[];

    private selected_group:TreeNode;
    selectedGroup : TreeNode;
    @Output() onSelect:EventEmitter<any> = new EventEmitter();

    constructor(private service:GuideService, private logger : Logger) {

    }
    ngOnInit() {
        this.loadUserGroup();
    }
    private onNodeSelect(event:any):void{
       if(this.onSelect != null){
            this.onSelect.emit(event.node);
       }
    }
    private loadUserGroup():void{
        var url_path = "/mgr/system/attribute/group";
        this.service.get(url_path,null,null).subscribe(
            value => {
                this.logger.debug("loadUserGroup : ", value);
                this.user_group = value;
            },
            error=>{
                this.logger.error("-- error : " + error);
            },
            ()=>{
                this.logger.info("-- complate : ");
            }
        )
    }
}

@NgModule({
    imports:[TreeModule,ContextMenuModule],
    declarations:[UserGroupTreeComponent],
    exports:[UserGroupTreeComponent],
    providers:[GuideService]
})
export class UserGroupTreeModule{
}



// WEBPACK FOOTER //
// C:/Users/sung/WebstormProjects/exafe front/src/app/component/user_tree.component.ts